import { KeyboardArrowDown } from '@mui/icons-material';
import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import { capitalizeStage } from '../utils';
export type OptionType = { value: string; label: string };

const DealDropdown = ({
  options,
  value,
  setValue,
  fieldName,
}: {
  options: OptionType[] | undefined;
  value: string;
  fieldName: string;
  setValue: (fieldName: string, value: string) => void;
}) => {
  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => {
          setValue(fieldName, e.target.value);
        }}
        renderValue={(selected) => {
          const selectedOption = options?.find((opt) => opt.value === selected);
          const displayText = selectedOption ? selectedOption.label : capitalizeStage(selected);
          return (
            <Typography
              component='span'
              sx={{ color: zeplinColor.BasicBlack, fontSize: '0.875rem' }}
            >
              {displayText}
            </Typography>
          );
        }}
        sx={{
          borderRadius: '50px',
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: zeplinColor.Neutral5,
          fontSize: '0.875rem',
          height: '28px',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            padding: '4px 28px 4px 12px',
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiSelect-icon': {
            color: zeplinColor.BasicBlack,
            right: '8px',
          },
        }}
        IconComponent={KeyboardArrowDown}
      >
        {options && options.length > 0 ? (
          options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No options available</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default DealDropdown;
